// Field hints of the guide editor (rez 10). Keys are referenced from the hint registry
// (`apps/admin/src/lib/webHints/guide.ts`). A "web" text names "<page> → <section>" without
// the "On the website:" prefix; a "backoffice" text continues "Not shown on the website, used for".
export const guide = {
  name: "Guide page → H1 heading; also the card on the Guides page, the guide strip on the country page and the guide block on the trip page",
  slug: "Page address → /pruvodce/<address>",
  yearsExperience: "Guide page, guide card and the block on the trip page → years of experience",
  livingIn: "Guide page, guide card and the block on the trip page → place of residence",
  bio: "Guide page → profile text; also the guide block on the trip page",
  specializations: "Guide page and guide card → specialization tags",
  photoMediaId:
    "Guide page, guide card, the guide strip on the country page and the block on the trip page → photo",
  countryIds:
    "Guide page → countries in the header; also the card on the Guides page and the guide strip on the country page. The first country is the home destination in the guide schedule",
  interview:
    "Guide page → the “We asked” section (questions in this order; without questions the section is hidden)",
  tips: "Guide page → tips (only filled-in fields; without tips the section is hidden)",
  galleryImageIds: "Guide page → gallery (the first 24 photos in this order)",
  homeDestinationId: "grouping the guide under the destination team in the guide schedule",
  sortOrder:
    "the order of guides in the guide schedule (the Guides page lists them alphabetically)",
  isActive:
    "Whole website → guide page, card on the Guides page, the guide strip on the country page, the profile link on specialist cards and the “Our guides” link in the menu (an inactive guide is hidden)",
};
